import { exportGetOrdersByCriteria, Filter, FilterOperator, getOrdersByCriteria } from '@nemuru-eng/js-api-client';

import { ApplicationTypeMap } from '@/config/maps/ApplicationType.map';
import { ApplicationType } from '@/config/types';
import { exportXLSX } from '@/utils/exportXLSX';
import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function useFetchOrderList({
  applicationType,
  additionalFilters,
}: {
  applicationType?: ApplicationType;
  additionalFilters?: Filter[];
}) {
  const queryAdditionalFilters = additionalFilters ?? [];

  const onboardingFulfilledByType = ApplicationTypeMap.toOnboardingFulfilled(applicationType);
  const onboardingFulfilledByFilter = onboardingFulfilledByType
    ? [
        {
          field: 'onboarding_fulfilled_by',
          operator: FilterOperator.IN,
          value: onboardingFulfilledByType.join(','),
        },
      ]
    : [];

  const fetchOrderList = async (query) => {
    const customFilters: Filter[] = queryAdditionalFilters.concat(onboardingFulfilledByFilter).concat(query?.filters);
    return fetchForDataGrid(getOrdersByCriteria, { ...query, filters: customFilters });
  };

  const fetchXLSXExport = (query) => {
    const customFilters = query?.filters;
    return exportXLSX(exportGetOrdersByCriteria, { ...query, filters: customFilters });
  };

  return { fetchOrderList, fetchXLSXExport };
}
